import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LoansService, StorageService, DataService } from 'src/app/_services';

@Component({
  selector: 'app-microcreditsummary',
  templateUrl: './microcreditsummary.component.html',
  styleUrls: ['./microcreditsummary.component.css']
})
export class MicrocreditsummaryComponent implements OnInit {
  @Input() from_where = '0';

  @Input() reqid = '';
  @Output() openMore = new EventEmitter();
  @Output() openMoreResult = new EventEmitter();
  view = 'list';
  currentUser: any;
  loading = false;
  statements: Array<any> = [];
  loan: any;
  statement: any;
  checking = [];
  viewing_transactions = false;
  has_data=false;
  summary :any;
  constructor(
    public loansService: LoansService,
    public storageService: StorageService,
    public dataService: DataService,
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    
  }

  ngOnInit() {
    this.getALlMicrocreditcheck();
  }

  runAnalytics(statement) {
    this.statement = statement;
    this.viewing_transactions = false;
  }

  viewTransactions(statement) {
    this.statement = statement;
    this.viewing_transactions = true;
  }

  viewResult(statement) {
    this.statement = statement;
    this.view = 'result';
  }

  done(statements) {
    this.getALlMicrocreditcheck();
  }

  cancel() {
    this.view = 'list';
    this.statement = null;
    this.viewing_transactions = false;
  }

  checkAnalytics(statement) {
    this.checking = [...this.checking, statement.ATTACHMENT_ID];
    this.loansService.checkBankStatementAnalysisStatus(this.currentUser.token, statement)
      .subscribe(data => {
        console.log(data);
        this.checking = this.checking.filter(s => s.ATTACHMENT_ID === statement.ATTACHMENT_ID);
      });
  }

  getALlMicrocreditcheck() {
    this.loading = true;
    this.loansService.getALlMicrocreditcheck(this.currentUser.token, this.reqid)
    .subscribe(data => {
      this.loading = false;
      this.has_data = data.data.count;
      this.summary = data.data.result;
    });
  }
  openResult(){
    this.openMoreResult.emit({summary: this.summary});
  }
}

